import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45226990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full px-1 pb-2 h-96 overflow-auto" }
const _hoisted_2 = { class: "grid grid-flow-row auto-rows-max" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "flex pb-2" }
const _hoisted_5 = { class: "mr-1 pt-5" }
const _hoisted_6 = { class: "col-span-12 border-l-4 font-bold rounded bg-buttonColor2Pressed" }
const _hoisted_7 = { class: "font-bold pl-2" }
const _hoisted_8 = { class: "mr-1 pt-5" }
const _hoisted_9 = { class: "col-span-12 border-l-4 font-bold rounded bg-buttonColor2Pressed" }
const _hoisted_10 = { class: "font-bold pl-2" }
const _hoisted_11 = { class: "col-span-12 border-l-4 font-bold border-infoColor text-infoColor mb-2" }
const _hoisted_12 = { class: "font-bold pr-4" }
const _hoisted_13 = { class: "font-bold pr-2 pl-2" }
const _hoisted_14 = { class: "col-span-12" }
const _hoisted_15 = { class: "flex flex-wrap" }
const _hoisted_16 = { class: "relative pb-2" }
const _hoisted_17 = { class: "grid grid-flow-row auto-rows-max" }
const _hoisted_18 = { class: "absolute z-10 text-black" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "p-2" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-black" }, null, -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "col-span-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_MdPerson = _resolveComponent("MdPerson")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_MdRemove = _resolveComponent("MdRemove")!
  const _component_n_progress = _resolveComponent("n-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_n_space, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_checkbox, {
                    type: "warning",
                    checked: _ctx.resNone.Status === _ctx.ParamParticapantStatus.All,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voteNone(_ctx.resNone, _ctx.resNone.Status === _ctx.ParamParticapantStatus.All ? _ctx.ParamParticapantStatus.Open: _ctx.ParamParticapantStatus.All))),
                    class: "w-full pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('AllOfTheAbove')), 1)
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  (_ctx.personAll.count > 0)
                    ? (_openBlock(), _createBlock(_component_n_popover, {
                        key: 0,
                        trigger: "hover"
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_n_button, { quaternary: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_icon, { class: "text-xl" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_MdPerson)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" x " + _toDisplayString(_ctx.personAll.count), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_n_tag, { type: "warning" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('replied')), 1)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.personAll.name), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_n_button, {
                        key: 1,
                        quaternary: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_icon, { class: "text-xl" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MdPerson)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" x " + _toDisplayString(_ctx.personAll.count), 1)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_n_space, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_checkbox, {
                    type: "warning",
                    checked: _ctx.resNone.Status === _ctx.ParamParticapantStatus.None,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.voteNone(_ctx.resNone, _ctx.resNone.Status === _ctx.ParamParticapantStatus.None ? _ctx.ParamParticapantStatus.Open: _ctx.ParamParticapantStatus.None))),
                    class: "w-full pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('NoneOfTheAbove')), 1)
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  (_ctx.personNone.count > 0)
                    ? (_openBlock(), _createBlock(_component_n_popover, {
                        key: 0,
                        trigger: "hover"
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_n_button, { quaternary: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_icon, { class: "text-xl" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_MdPerson)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" x " + _toDisplayString(_ctx.personNone.count), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_n_tag, { type: "warning" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('replied')), 1)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.personNone.name), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_n_button, {
                        key: 1,
                        quaternary: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_icon, { class: "text-xl" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MdPerson)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" x " + _toDisplayString(_ctx.personNone.count), 1)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseGroupList, (responseList) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-span-12 mt-3",
          key: responseList.week
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, "  " + _toDisplayString(responseList.week), 1),
            _createVNode(_component_n_checkbox, {
              checked: responseList.checkAll == 'Y',
              onClick: ($event: any) => (_ctx.userMultiVote(responseList.items, responseList.checkAll == 'Y'? 'N': 'Y')),
              disabled: _ctx.resNone.Status === _ctx.ParamParticapantStatus.None
            }, null, 8, ["checked", "onClick", "disabled"]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('AllOfTheDate')), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responseList.items, (col) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mr-1",
                  key: col.EventScheduleId
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_n_checkbox, {
                              class: "w-full",
                              checked: col.Status === _ctx.ParamResponseStatus.Agree,
                              onClick: ($event: any) => (_ctx.userVote(_ctx.event?.EventHeaderId ?? '',
                              col?.EventScheduleId ?? '',
                              col.EventParticipantId,
                              col.ParticipantResponseId ?? '',
                              col.Status === _ctx.ParamResponseStatus.Agree? _ctx.ParamResponseStatus.Deny: _ctx.ParamResponseStatus.Agree
                              )),
                              disabled: _ctx.resNone.Status === _ctx.ParamParticapantStatus.None,
                              style: _normalizeStyle({'--color-checked': _ctx.themeVars.infoColor, '--border-checked': '1px solid' + _ctx.themeVars.infoColor, '--border-focus': _ctx.themeVars.infoColor, '--border:': _ctx.themeVars.infoColor})
                            }, null, 8, ["checked", "onClick", "disabled", "style"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createTextVNode(" " + _toDisplayString(_ctx.startTimeDisplay(col.ScheduleStartUTCDateTime)) + " ", 1),
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_MdRemove)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.endTimeDisplay(col.ScheduleEndUTCDateTime)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            (_ctx.eventResponseFilter(col?.EventScheduleId ?? '')!=='')
                              ? (_openBlock(), _createBlock(_component_n_popover, {
                                  key: 0,
                                  trigger: "hover"
                                }, {
                                  trigger: _withCtx(() => [
                                    _createVNode(_component_n_button, { quaternary: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_n_icon, { class: "text-xl" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_MdPerson)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" x " + _toDisplayString(col.AgreeCount), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                      _createVNode(_component_n_tag, { type: "warning" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('replied')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.eventResponseFilter(col?.EventScheduleId ?? '')), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(_component_n_button, { quaternary: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_n_icon, { class: "text-xl" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_MdPerson)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" x " + _toDisplayString(col.AgreeCount), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_n_progress, {
                          type: "line",
                          percentage: _ctx.percentage(col.AgreeCount, _ctx.event?.HeadCount ?? 1),
                          height: 36,
                          "border-radius": 4,
                          "fill-border-radius": 0,
                          "show-indicator": false,
                          color: 
                          col.Status === _ctx.ParamResponseStatus.Agree
                          ?_ctx.changeColor(_ctx.themeVars.warningColor,{ alpha: 1 })
                          :_ctx.changeColor(_ctx.themeVars.buttonColor2,{ alpha: 0.4 }),
                          class: "w-52",
                          "rail-color": 
                          _ctx.changeColor(
                            col.Status === _ctx.ParamResponseStatus.Agree
                              ? _ctx.themeVars.warningColor
                              : _ctx.themeVars.buttonColor2,
                            { alpha: 0.2 }
                          )
                        
                        }, null, 8, ["percentage", "color", "rail-color"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}